import { UserRepository } from "../../../domain/repositories/UserRepository";
import { createHttpClients } from "../shared/createHttpClients";

class UserRepositoryImpl implements UserRepository {
  private static instance: UserRepositoryImpl;

  private constructor() {}

  public static getInstance(): UserRepositoryImpl {
    if (!UserRepositoryImpl.instance) {
      UserRepositoryImpl.instance = new UserRepositoryImpl();
    }

    return UserRepositoryImpl.instance;
  }

  public async hasPurchase(auth: string, apiUrl: () => string): Promise<boolean> {
    try {
      const { httpGet } = createHttpClients(auth, apiUrl);
      const { active = false } = await httpGet<{ active?: boolean }>({
        endpoint: `/users/v1/has-purchase`,
      });
      return active;
    } catch (error) {
      console.log(error);
      throw new Error("hasPurchase");
    }
  }

  public async logLastAccess(auth: string, apiUrl: () => string): Promise<void> {
    try {
      const { httpPut } = createHttpClients(auth, apiUrl);
      await httpPut({
        endpoint: `/onboardings/v1/log-last-access`,
        body: {},
      });
    } catch (error) {
      console.log(error);
      return Promise.reject("logLastAccess");
    }
  }
}

export { UserRepositoryImpl };
